import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AdminSettingsService } from 'src/app/shared/admin-settings.service';
import { Helper } from 'src/app/shared/helper';

declare var google: any;

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent {

  contactForm!: FormGroup;
  private readonly defaultContacts = [
    { name: 'Keval Pipaliya', phone: '84695 97893' },
    { name: 'Bhutik Pipaliya', phone: '99047 12754' },
    { name: 'Office', phone: '95866 61298' },
  ];
  constructor(public helper: Helper, private _fb: FormBuilder,private adminSetting:AdminSettingsService) { }

  ngOnInit(): void {
    this.__initForm();
  }

  __initForm() {
    this.contactForm = this._fb.group({
      message: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email, Validators.pattern(this.helper.emailValidationRegex)]],
    });
  }

  get companyContacts(): Array<{ name: string; phone: string }> {
    const settings = this.helper.adminSettings || {};
    return [
      {
        name: settings.contactPerson1Name || this.defaultContacts[0].name,
        phone: settings.contactPerson1Phone || this.defaultContacts[0].phone,
      },
      {
        name: settings.contactPerson2Name || this.defaultContacts[1].name,
        phone: settings.contactPerson2Phone || this.defaultContacts[1].phone,
      },
      {
        name: settings.officeName || this.defaultContacts[2].name,
        phone: settings.officePhone || settings.mobile || this.defaultContacts[2].phone,
      },
    ].filter((contact) => contact.name || contact.phone);
  }

  get companyAddress(): string {
    return this.helper.adminSettings?.address || 'Shree Ranchhod Nagar, Street No. 3, Sant Kabir Road, Imitation Market, Rajkot (Guj).';
  }

  get companyEmail(): string {
    return this.helper.adminSettings?.email || '';
  }

  onSubmit(): void {
    // Trim each string value in the form controls
    Object.keys(this.contactForm.controls).forEach(controlName => {
      const control = this.contactForm.get(controlName);

      if (control && typeof control.value === 'string') {
        // Trim the string value
        control.setValue(control.value.trim());
      }
    });

    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();
      return;
    }
    let json: any = {
      firstName: this.contactForm.value.firstName,
      lastName: this.contactForm.value.lastName,
      email: this.contactForm.value.email,
      message: this.contactForm.value.message,
    };

    this.adminSetting.sendMessage(json).subscribe((res) => {
      if (res) {
        this.contactForm.reset();
      }
    });

  }

}
